module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-app/src/templates/alertView.html -->\n<div class="container app-alert">\n	<header class="header"></header>\n	<div class="container-fluid">\n		<p>'+
((__t=( msg ))==null?'':__t)+
'</p>\n	</div>\n	<footer>\n		<div class="actions close single">\n			<button data-nx-control="close" type="button" class="btn btn-info" name="no" data-i18n="i18n.ok">i18n.ok</button>\n		</div>\n	</footer>\n</div>';
}
return __p;
};
